import React from 'react'
import { FormSectionTwoColumns } from '../../../../../../../components/forms/FormSectionTwoColumns'
import { B4WaterFields } from '../B4TechnicalInfractructureConnection/B4WaterFields'
import { IsDisabledContext } from '../../../../../../../model/context/IsDisabledContext'
import { AccompanyingReportInputsPreview } from '../../../../../../../components/AccompanyingReportInputsPreview'
import { RoutesEnum } from '../../../../../../../model/enums/RoutesEnum'
import { ProjectFormEnum } from '../../../../../../../model/enums/ProjectFormEnum'

interface Props {}

export const B8WatermanagementForm: React.FC<Props> = (props) => {
  return (
    <>
      <FormSectionTwoColumns
        sectionKey="b8.technicalInfrastructureConnection"
        title="Zejména zásobování stavby vodou, způsob zneškodňování odpadních vod, využití a nakládání se srážkovými vodami"
        subtitle="(Obsah tohto bodu byl již vyplněn v sekci B4)"
      >
        <div className="sm:col-span-6">
          <AccompanyingReportInputsPreview
            label="Údaje z B.4 Připojení na technickou infrastrukturu"
            targetForm={`${RoutesEnum.TECHNICAL_REPORT_FORM}/${ProjectFormEnum.TECHNICAL_FORM_B4}`}
          >
            <IsDisabledContext.Provider value={true}>
              <B4WaterFields />
            </IsDisabledContext.Provider>
          </AccompanyingReportInputsPreview>
        </div>
      </FormSectionTwoColumns>
    </>
  )
}
